import React from 'react';
import { Card, CardBody } from '@heroui/react';
import { motion } from 'framer-motion';

const RegisterConfirmationPage: React.FC = () => {
  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="max-w-md mx-auto"
        >
          <Card className="border border-divider">
            <CardBody className="p-8 text-center">
              <h2 className="text-2xl font-medium mb-4">Спасибо за регистрацию!</h2>
              <p className="text-foreground/70">На указанный адрес электронной почты отправлено письмо с ссылкой для подтверждения регистрации. Пожалуйста, подтвердите вашу почту — после этого вы сможете войти в систему.</p>
            </CardBody>
          </Card>
        </motion.div>
      </div>
    </section>
  );
};

export default RegisterConfirmationPage;
